module.exports = __webpack_public_path__ + "img/folder-tree.41f4d406.svg";